module.exports = __webpack_public_path__ + "img/ring_r_s_null_null@3x.4c130200.png";